/*!
 * Copyright © 2019-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'shared';
import { TachoMessageSectionComponent } from './tacho-message-section.component';

@NgModule({
  declarations: [TachoMessageSectionComponent],
  exports: [TachoMessageSectionComponent],
  imports: [TooltipModule, MatIconModule, CommonModule, ClipboardModule]
})
export class TachoMessageSectionModule {}
